import { SupportedLanguages } from "@repo/database";
import { set as setDateFns } from "date-fns";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface GeneralState {
  language: SupportedLanguages;
  theme: "light" | "dark";
  floorPlanPosition: { x: number; y: number };
  setFloorPlanPosition: (position: { x: number; y: number }) => void;
  setTheme: (theme: "light" | "dark") => void;
  floorPlanZoom: number;
  setFloorPlanZoom: (zoom: number) => void;
  setLanguage: (language: SupportedLanguages) => void;
  layoutCalendarOpen: boolean;
  setLayoutCalendarOpen: (layoutCalendarOpen: boolean) => void;
  selectedDate: string;
  setSelectedDate: (selectedDate: Date) => void;
  buttonSoundEnabled: boolean;
  setButtonSoundEnabled: (buttonSoundEnabled: boolean) => void;
  mobileNavExpanded: boolean;
  setMobileNavExpanded: (mobileNavExpanded: boolean) => void;
}

export const useGeneralStore = create<GeneralState>()(
  devtools(
    persist(
      (set) => ({
        floorPlanZoom: 1,
        floorPlanPosition: { x: 0, y: 0 },
        setFloorPlanPosition(position) {
          set(() => ({ floorPlanPosition: position }));
        },
        setFloorPlanZoom(zoom) {
          set(() => ({ floorPlanZoom: zoom }));
        },
        theme: "light",
        setTheme(theme) {
          set(() => ({ theme }));
        },
        mobileNavExpanded: false,
        setMobileNavExpanded(mobileNavExpanded) {
          set(() => ({ mobileNavExpanded }));
        },
        buttonSoundEnabled: false,
        language: SupportedLanguages.en,
        selectedDate: new Date().toISOString(),
        setButtonSoundEnabled(buttonSoundEnabled) {
          set(() => ({ buttonSoundEnabled }));
        },
        setSelectedDate: (selectedDate) => {
          set(() => ({
            selectedDate: setDateFns(new Date(), {
              date: selectedDate.getDate(),
              month: selectedDate.getMonth(),
              year: selectedDate.getFullYear(),
            }).toISOString(),
          }));
        },
        layoutCalendarOpen: false,
        setLayoutCalendarOpen: (layoutCalendarOpen) => {
          set(() => ({ layoutCalendarOpen }));
        },
        setLanguage: (language) => {
          set(() => ({ language }));
        },
      }),
      {
        name: "general-storage",
      },
    ),
  ),
);
